import React from 'react';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const UserFilesHelp = ({ t }) => {
  const [open, setOpen] = React.useState(true);
  const collapseId = 'user-files-help';

  return (
    <Alert
      icon={<HelpOutlineIcon sx={{ mt: 0.5 }} />}
      severity="info"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
        py: 1.5,
        px: 2,
      }}
      action={
        <IconButton
          size="small"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={collapseId}
          aria-label={
            open
              ? t?.('files.help.collapse', 'Skryť návod')
              : t?.('files.help.expand', 'Zobraziť návod')
          }
          sx={{ mt: 0.5, color: 'inherit' }}
        >
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      }
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t?.('files.help.title', 'Ako to funguje')}
      </Typography>

      <Collapse in={open} timeout="auto" id={collapseId}>
        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'files.help.p1',
              'V tejto časti vidíte všetky dokumenty, ktoré ste do aplikácie nahrali na anonymizáciu.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'files.help.p2',
              'Súbory tu môžete stiahnuť, odstrániť a v prípade potreby vykonať aj manuálnu anonymizáciu kliknutím na „Manuálne anonymizovať“ pri PDF dokumente.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'files.help.p3',
              'V editore manuálnej anonymizácie zapnite kreslenie, označte časť dokumentu a pre posúvanie dokumentu kreslenie vypnite. Následne kliknite na anonymizovať dokument.'
            )}
          </Typography>

          <Box
            sx={(theme) => ({
              mt: 1,
              p: 1.5,
              borderRadius: 1.5,
              border: '1px dashed',
              borderColor: 'info.main',
              bgcolor: alpha(theme.palette.info.main, 0.08),
            })}
          >
            <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, color: 'info.main' }}>
              💡 {t?.('files.help.tipsTitle', 'Tipy')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
              •{' '}
              {t?.(
                'files.help.tipSign',
                'Chcete dokumenty podpisovať elektronicky? Je to možné - používateľ môže podpisovať dokumenty prostredníctvom mobilného telefónu.'
              )}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, lineHeight: 1.5 }}>
              •{' '}
              {t?.(
                'files.help.tipSearch',
                'Chcete v dokumentoch vyhľadávať? Stačí použiť pole „Hľadať v dokumentoch“ a systém vyhľadá údaje aj v naskenovaných PDF súboroch.'
              )}
            </Typography>
          </Box>
        </Stack>
      </Collapse>
    </Alert>
  );
};

export default UserFilesHelp;